import React, { useRef } from 'react';
import { m, useInView } from 'framer-motion';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Card, CardContent, CardMedia, Grid, useColorScheme } from '@mui/material';

import { CONFIG } from 'src/global-config';
import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

const iconPath = (name) => `${CONFIG.assetsDir}/assets/icons/duotone/${name}`;

// ----------------------------------------------------------------------

// export function CorporatePaymentOptions({ sx, ...other }) {
//   const { t } = useLocale();

//   const { mode } = useColorScheme();
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, margin: '-100px' });

//   const renderCards = () => (
//     <>
//       {STEPS?.map((item, index) => (
//         <m.div
//           key={index}
//           initial={{ opacity: 0, y: 60 }}
//           animate={isInView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.8, delay: 0.2 * index, ease: 'easeOut' }}
//         >
//           <Card
//             sx={{
//               bgcolor: 'background.whitePaper',
//               boxShadow: 3,
//               borderRadius: 2,
//               overflow: 'hidden',
//               height: 500,
//             }}
//           >
//             <CardMedia
//               sx={{ height: 350, objectFit: 'cover' }}
//               image={`${CONFIG.assetsDir}${item?.image}`}
//               title={item?.title}
//               alt={item?.alt}
//             />
//             <CardContent sx={{}}>
//               <Typography gutterBottom variant="h5">
//                 {t(item?.title)}
//               </Typography>
//               <Typography variant="body2" sx={{ color: 'text.secondary' }}>
//                 {t(item?.description)}
//               </Typography>
//             </CardContent>
//           </Card>
//         </m.div>
//       ))}
//     </>
//   );
//   const STEPS = [
//     {
//       title: 'Deferred_Payment_Agreements',
//       description: 'Deferred_Payment_Agreements_Description',
//       icon: 'streamline:payment-10', // Iconify
//       image: '/assets/images/business/flatbed-truck-ksa-خدمات-النقل-البارد.webp',
//       alt: t('Global_Logistics_Services'),
//     },
//     {
//       title: 'Prepaid_Wallet_System',
//       description: 'Prepaid_Wallet_System_Description',
//       icon: 'mdi-light:wallet', // Local SVG
//       image: '/assets/images/business/heavy-truck-rental-النقل-المبرد.webp',
//       alt: t('All_rights_reserved'),
//     },
//     {
//       title: 'Real_Time_Online_Payments',
//       description: 'Real_Time_Online_Payments_Description',
//       icon: 'material-symbols-light:payments-outline', // Local SVG
//       image: '/assets/images/business/cold-storage-transport-نقليات-ثقيلة.webp',
//       alt: t('Freight_Forwarding_Solutions'),
//     },
//   ];
//   return (
//     <Box
//       component="section"
//       ref={ref}
//       sx={[
//         {
//           textAlign: 'center',
//           pb: { xs: 5, md: 10 },
//           pt: { xs: 5, md: 10 },
//           bgcolor: 'background.whitePaper',
//         },
//         ...(Array.isArray(sx) ? sx : [sx]),
//       ]}
//       {...other}
//     >
//       <Container>
//         {/* Section Header */}
//         <m.div
//           initial={{ opacity: 0, y: 40 }}
//           animate={isInView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.8, ease: 'easeOut' }}
//         >
//           <Typography variant="h2" sx={{ my: 3, fontSize: '2.5rem !important' }}>
//             {t('Corporate_Payment_Options')}
//           </Typography>

//           <Typography variant="h4" sx={{ mb: 5, maxWidth: 400, textAlign: 'center', mx: 'auto' }}>
//             {t('Empowering_financial_flexibility_for_logistics_continuity')}
//           </Typography>

//           <Typography sx={{ color: 'text.secondary', maxWidth: 800, mx: 'auto' }}>
//             {t('corporate_desc')}
//           </Typography>
//         </m.div>

//         {/* Step Cards */}
//         <Box
//           sx={{
//             gap: 5,
//             display: 'grid',
//             my: { xs: 5, md: 10 },
//             gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)' },
//           }}
//         >
//           {renderCards()}
//         </Box>

//         {/* Footer Text */}
//         <m.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={isInView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.8, delay: 0.6, ease: 'easeOut' }}
//         >
//           <Typography sx={{ color: 'text.secondary', maxWidth: 800, mx: 'auto' }}>
//             {t('Corporate_Under_Desc')}
//           </Typography>
//         </m.div>
//       </Container>
//     </Box>
//   );
// }

export function BusinessSectors({ sx, ...other }) {
  const { t } = useLocale();

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const bulletPoints = [
    'Manufacturing_Industrial_Production',
    'Construction_Building_Materials',
    'Food_FMCG_Distribution',
    'Retail_Wholesale_Distribution',
    'Government_Public_Sector',
    'Logistics_Supply_Chain_Operations',
  ];

  return (
    <Box
      component={m.section}
      ref={ref}
      initial={{ opacity: 0, y: 60 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      sx={[
        {
          py: { xs: 5, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Grid
          container
          spacing={3}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: { xs: 'column-reverse', md: 'row' },
          }}
        >
          {/* Text Section */}
          <Grid sx={{ textAlign: { xs: 'center', md: 'left' } }} size={{ xs: 12, md: 6, lg: 6 }}>
            <m.div
              initial={{ opacity: 0, x: 50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              <Typography variant="h2" component="h2" sx={{ fontSize: '2rem !important' }}>
                {t('An_Integrated_Fleet_Serving_All_Sectors')}
              </Typography>

              <Typography sx={{ mt: 3, mb: 5, color: 'text.secondary' }}>
                {t('Shahen_Provides_an_Extensive_and_Integrated_Truck_Fleet')}
              </Typography>

              {/* Bullet list */}
              {/* <Box
                component="ul"
                sx={{
                  mb: 5,
                  gap: 1.5,
                  display: 'flex',
                  flexDirection: 'column',
                  pl: 3,
                  color: 'text.secondary',
                  textAlign: 'left',
                  listStyleType: 'disc',
                  '& li::marker': {
                    color: 'green',
                    fontSize: '1.1rem',
                  },
                }}
              >
                {bulletPoints?.map((text, index) => (
                  <m.li
                    key={index}
                    initial={{ opacity: 0, x: 30 }}
                    animate={isInView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
                  >
                    {t(text)}
                  </m.li>
                ))}
              </Box> */}
            </m.div>
          </Grid>
          {/* Image Section */}
          <Grid size={{ xs: 12, md: 6, lg: 5 }}>
            <m.div
              initial={{ opacity: 0, x: -50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.2 }}
            >
              <Box
                component="img"
                alt={t('business-page-img1-title')}
                title={t('business-page-img1-meta-desk')}
                src={`${CONFIG.assetsDir}/assets/images/home/seo/Business-Solutions/shahen-fleet-for-all-sectors.webp`}
                sx={{
                  display: 'block',
                  width: '100%',
                  height: 480,
                  borderRadius: 2,
                  maxWidth: { xs: 300, sm: 400, md: 480 },
                  mx: 'auto',
                  maxHeight: { xs: 200, sm: 300, md: 480 },
                  objectFit: 'cover',
                }}
              />
            </m.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
